import { debounceSecond } from 'assets/constant';
import { CardHeader } from 'components/common';
import BreadCrumb from 'components/shared/BreadCrumb';
import { useSupporting } from 'hooks';
import { useNoticeState } from 'hooks/supporting/useNoticeState';
import { usePostSupporting } from 'hooks/supporting/usePostSupporting';
import usePutSupporting from 'hooks/supporting/usePutSupporting';
import { debounce } from 'lodash';
import { BoardContent, BoardFixed, BoardPublic, BoardTitle } from 'pages/supporting';
import { BoardEditFile } from 'pages/supporting/BoardEditFile';
import { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router';
import { BoardTypeReference } from './BoardTypeReference';

export const ReferenceEdit = () => {
  const { referenceId } = useParams();
  const navigate = useNavigate();
  const {
    noticeState,
    handleTitleChange,
    handleContentChange,
    handlePostStateChange,
    handlePostTypeChange,
    handleTopFixFlagChange,
    handleFileChange,
    resetNoticeState,
    handleEditFileChange,
  } = useNoticeState();
  const { editFaqMutation } = usePutSupporting(referenceId);
  const { editFileMutate } = usePostSupporting(referenceId);

  const {
    // 자료실 디테일 데이터 불러오기
    referenceDetailData,
    referenceDetailIsLoading,
    referenceDetailIsError,
  } = useSupporting(referenceId);

  const debounceHandleSubmit = debounce(async () => {
    const { fileList, thumbnail, editFileList, ...boardPostData } = noticeState;
    try {
      const formData = new FormData();
      if (fileList.length > 0)
        fileList.forEach((file) => {
          formData.append('mediaList', file);
        });

      editFaqMutation.mutate(boardPostData);
      if (fileList.length > 0) editFileMutate.mutate(formData);
      navigate(`/reference/detail/${referenceId}`);
    } catch (error) {
      console.error('error', error);
    }
  }, debounceSecond);

  const handleSubmit = (e) => {
    e.preventDefault();
    debounceHandleSubmit();
  };

  useEffect(() => {
    if (!referenceDetailData) return;
    const { title, content, postState, postType, topFixFlag, mediaInfoDtoList } = referenceDetailData;
    handleTitleChange(title);
    handleContentChange(content);
    handlePostStateChange(postState);
    handlePostTypeChange(postType);
    handleTopFixFlagChange(topFixFlag);
    handleEditFileChange(mediaInfoDtoList);
    return () => {
      resetNoticeState();
    };
  }, [referenceDetailData]);

  return (
    <>
      <main id='main' className='main'>
        <BreadCrumb home={'/'} sublink={'/faq'} title={'Help Center'} subTitle={'지원센터'}>
          &nbsp;/ 자료실 / 공지 등록/수정
        </BreadCrumb>
        <div className='card p-20'>
          <CardHeader noRightBorder={false} title='공지사항' visibleContent={false}></CardHeader>

          <Form onSubmit={handleSubmit} action='' className='write-form'>
            {/* <BoardType value={noticeState.postType} onChange={handlePostTypeChange} /> */}
            <BoardTypeReference />
            <BoardTitle value={noticeState.title} onChange={handleTitleChange} />
            <BoardPublic value={noticeState.postState} onChange={handlePostStateChange} />
            <BoardFixed value={noticeState.topFixFlag} onChange={handleTopFixFlagChange} />
            {/* <BoardThumbnail value={noticeState.thumbnail} onChange={handleThumbnailChange} /> */}
            <BoardContent value={noticeState.content} onChange={handleContentChange} />

            <BoardEditFile value={noticeState.fileList} onChange={handleFileChange} />

            {/* 첨부파일 */}

            <div className='d-flex align-items-center justify-content-center border-top pt-3'>
              <Button type='submit' variant='primary' className='me-2'>
                등록
              </Button>
              <Button variant='secondary'>취소</Button>
            </div>
          </Form>
        </div>
      </main>
    </>
  );
};
